import _ from 'underscore';
import twemoji from 'twemoji';

import webcall from '@/scripts/webcall';

const _question = {
  id: '',
  topic: '',
};

const _initPageData = function _initPageData() {
  // Sets the page's question topic.
  _question.id = $('#question__related-topics').data('question-id');
  _question.topic = $('#question__related-topics')
    .data('question-topic')
    .toLowerCase()
    .replace(/ /g, '-')
  ;

  _loadRelatedQuestions();
};

const _bindUIActions = function _bindUIActions() {};

const _loadRelatedQuestions = async function _loadRelatedQuestions() {
  try {
    const { questions } = await webcall.community.getQuestionsByTopic({
      topic: _question.topic,
    });

    const tplQuestionContainer = _.template($('.tpl-related-question-container').html());
    const tplQuestion = _.template($('.tpl-related-question').html());

    const card = {
      topic: _question.topic,
      questions: questions
        .filter(({ id }) => id !== _question.id)
        .slice(0, 5)
        .map((question) => {
          const totalReaction = question.reactions.reduce((acc, { total }) => (acc + total), 0);
          const totaResponse = question.comment_count + totalReaction;

          return ({
            ...question,
            total_response: totaResponse,
          });
        })
        .map(question => tplQuestion({ question }))
      ,
    };

    $('#question__related-topics').append(tplQuestionContainer({ card }));

    twemoji.parse(document.getElementById('question__related-topics'));
  } catch (error) {
    // TODO: Better error handling.
  }
};

const VSRelatedQuestion = {
  init() {
    _initPageData();
    _bindUIActions();
  },
};

export default VSRelatedQuestion;
